<template>
  <LayoutSection
    paddingClass="pt-12 sm:pt-12 md:pt-12 lg:pt-32 pb-12 sm:pb-14 md:pb-14 lg:pb-20"
    sectionClass="mt-[2.5rem] sm:mt-[2.5rem] md:mt-[2.5rem] lg:mt-[4rem]"
  >
    <h1 class="sr-only">{{ $t("seoHomeH1") }}</h1>
    <div class="space-y-10">
      <div class="space-y-4 sm:space-y-5 text-left">
        <div class="space-y-6">
          <h2
            class="text-black font-semibold leading-tight text-[2rem] sm:text-[2.6rem] md:text-[3.4rem] lg:text-[4rem]"
          >
            "{{ $t("Functional medicine treats the person as a whole") }}:
            {{ $t("mind, body, and spirit") }}"
          </h2>
          <p
            class="text-black font-semibold leading-tight text-[2rem] sm:text-[2.6rem] md:text-[3.4rem] lg:text-[4rem]"
          >
            {{ $t("- Andrew Weil") }}
          </p>
        </div>
        <p
          class="text-[#627282] font-medium leading-[1.25] sm:leading-[1.35] md:leading-[1.45] text-[12px] sm:text-[12px] md:text-[14px] max-w-[36rem] sm:max-w-[52rem] lg:mt-10"
        >
          {{
            $t(
              "Find and book appointments with your healthcare professional or join their classes, one-off sessions, and experiences.",
            )
          }}
        </p>
      </div>

      <div class="pt-2 sm:pt-4">
        <SearchCommonSection v-model="filters" />
      </div>

      <!-- Popular-search chips hidden: therapy slugs have no taxonomy behind them yet -->
      <!--
      <div class="flex flex-wrap items-center justify-center gap-2">
        <span class="text-[#627282] text-[12px] font-medium shrink-0">{{ $t('Popular') }}:</span>
        <button
          v-for="chip in popularSearches"
          :key="chip.label"
          class="popular-chip"
          @click="handleChipSearch(chip)"
        >
          {{ chip.label }}
        </button>
      </div>
      -->
    </div>
  </LayoutSection>
</template>

<script lang="ts" setup>
import LayoutSection from "@/components/design/layoutSection.vue";
import SearchCommonSection from "@/components/search/searchCommonSection.vue";
import { useRouter } from "vue-router";
import { useIntroSection } from "./useIntroSection";

const {
  filters,
} = useIntroSection();

const router = useRouter();

const popularSearches = [
  { label: "Medicina funcional", therapy: "functional-medicine" },
  { label: "Nutrición", therapy: "nutrition" },
  { label: "Terapia neural", therapy: "neural-therapy" },
  { label: "Acupuntura", therapy: "acupuncture" },
  { label: "Breathwork", therapy: "breathwork" },
];

function handleChipSearch(chip: { label: string; therapy: string }) {
  router.push({
    path: "/search",
    query: {
      online: "1",
      inPerson: "1",
      therapy: chip.therapy,
    },
  });
}
</script>

<style scoped>
.popular-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 1.2rem;
  border-radius: 999px;
  border: 1px solid rgba(91, 111, 238, 0.25);
  background: rgba(91, 111, 238, 0.06);
  color: #5B6FEE;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.popular-chip:hover {
  background: rgba(91, 111, 238, 0.14);
  border-color: rgba(91, 111, 238, 0.45);
  color: #4558e0;
}
</style>
